import { z } from "zod";

import { ANNUAL_MULTI_TRIP, SINGLE_TRIP } from "@/constants";

import {
  dateTypePageData,
  dateTypeFormContent,
  dateTypeSupportContent,
} from "../utils/schema/travel-dates.schema.utils";

export type TravelDateSupportContent = z.infer<typeof dateTypeSupportContent>;
export type TravelDateFormContent = z.infer<typeof dateTypeFormContent>;
export type TravelDatePageContent = z.infer<typeof dateTypePageData>;

export type TravelDatePageType = Readonly<{
  magnoliaData: TravelDatePageContent;
}>;

export type DateRange<TDate> = [TDate | null, TDate | null];

export type TravelDates = {
  validate: boolean;
  startDate: Date | null;
  endDate: Date | null;
};

export type TravelDatesContextType = {
  travelDates: TravelDates;
  setTravelDates: React.Dispatch<React.SetStateAction<TravelDates>>;
};

export type TripType = typeof ANNUAL_MULTI_TRIP | typeof SINGLE_TRIP;
export type SelectionType = "DEFAULT" | "SELECTED";
export type TravelDatesModalType = "SameLocation" | "SameDay" | null;

// Map for groupedMagnoliaData keys
export const keyMap = {
  [ANNUAL_MULTI_TRIP]: {
    DEFAULT: "ANNUAL_MULTI_TRIP_DEFAULT",
    SELECTED: "ANNUAL_MULTI_TRIP_SELECTED",
  },
  [SINGLE_TRIP]: {
    DEFAULT: "SINGLE_TRIP_DEFAULT",
    SELECTED: "SINGLE_TRIP_SELECTED",
  },
} as const;

export type GroupedTravelDatesMagnoliaDataType = {
  [key in
    | "SINGLE_TRIP_DEFAULT"
    | "ANNUAL_MULTI_TRIP_DEFAULT"
    | "SINGLE_TRIP_SELECTED"
    | "ANNUAL_MULTI_TRIP_SELECTED"]: {
    headerText: string;
    descriptionSection: {
      title: string;
      body: string;
      isLoadMoreButton: boolean;
      loadMoreButtonText: string;
      drawerData: object | null | undefined;
    };
    errorMessage: {
      departureDateFutureErrorMessage?: string;
      departureDatePastErrorMessage?: string;
      returnDateFutureErrorMessage?: string;
      returnDatePastErrorMessage?: string;
      invalidDateErrorMessage?: string;
    };
    modalContent: {
      sdtButtonText?: string;
      sdtHeaderText?: string;
      sdtSubText?: string;
      thcButtonText?: string;
      thcHeaderText?: string;
      thcSubText?: string;
    };
    stLoadMoreButton?: boolean;
    amtLoadMoreButton?: boolean;
  };
};

export type EndDateValidationTypeST = {
  setTravelDates: (dates: {
    validate: boolean;
    startDate: Date | null;
    endDate: Date | null;
  }) => void;
  setError: (message: string) => void;
  startDate: Date;
  endDate: Date;
  errorMessage: {
    departureDateFutureErrorMessage?: string;
    departureDatePastErrorMessage?: string;
    returnDateFutureErrorMessage?: string;
    returnDatePastErrorMessage?: string;
    invalidDateErrorMessage?: string;
  };
  maxDateForReturnST: Date;
};

export type StartDateValidationTypeST = {
  setError: (message: string) => void;
  startDate: Date;
  errorMessage: {
    departureDateFutureErrorMessage?: string;
    departureDatePastErrorMessage?: string;
    returnDateFutureErrorMessage?: string;
    returnDatePastErrorMessage?: string;
    invalidDateErrorMessage?: string;
  };
  maxFromDate: Date;
  maxDateForReturnST: Date;
};

export type StartDateValidationTypeAMT = {
  date: Date;
  errorMessage: {
    departureDateFutureErrorMessage?: string;
    departureDatePastErrorMessage?: string;
    returnDateFutureErrorMessage?: string;
    returnDatePastErrorMessage?: string;
    invalidDateErrorMessage?: string;
  };
  maxDateforAMT: Date;
  setError: (message: string) => void;
};
